import { jsx as _jsx } from "react/jsx-runtime";
import RecommendationsBasedOnField from '../components/Recommendations/RecommendationsBasedOnField';
import RecommendationsBasedOnInterest from '../components/Recommendations/RecommendationsBasedOnInterest';
import RecommendationsBasedOnProgress from '../components/Recommendations/RecommendationsBasedOnProgress';
import RecommendationsSkeleton from '../components/Recommendations/RecommendationsSkeleton';
import { usePrioritizeInterestRecommendations, useRecommendations, useRecommendationsTopicPreference } from '../features/recommendations';
import { useSavedLearningInterest } from '../features/wizard';
import useWizard from '../hooks/useWizard';

const RecommendationsContainer = () => {
  const {
    prioritizeInterestRecommendations,
    isLoading: prioritizeInterestRecommendationsLoading,
    hasError: prioritizeInterestRecommendationsError
  } = usePrioritizeInterestRecommendations();
  const {
    recommendations: response,
    recommendationsLoading,
    recommendationsError
  } = useRecommendations();
  const {
    recommendations
  } = response || {};
  const hasProgressRecommendations = recommendations && recommendations.length && recommendations[0].recommendationStrategy === 'USER_INTERACTION';
  const savedLearningInterest = useSavedLearningInterest();
  const {
    isRequesting: isLoadingWizardResults,
    error: wizardResultsError
  } = useWizard(savedLearningInterest);
  const {
    recommendationsTopicPreferenceLoading
  } = useRecommendationsTopicPreference();
  const {
    hasLearningInterest,
    isLoadingLearningInterest,
    learningInterestError
  } = savedLearningInterest;
  const isRequesting = recommendationsLoading || isLoadingLearningInterest || prioritizeInterestRecommendationsLoading || isLoadingWizardResults || recommendationsTopicPreferenceLoading;
  const error = recommendationsError || learningInterestError || prioritizeInterestRecommendationsError || wizardResultsError;
  return /*#__PURE__*/_jsx("div", {
    "data-loading": isRequesting,
    "data-test-id": "recommendation-cards-container",
    children: isRequesting || error ? /*#__PURE__*/_jsx(RecommendationsSkeleton, {
      error: error
    }) : hasProgressRecommendations && !prioritizeInterestRecommendations ? /*#__PURE__*/_jsx(RecommendationsBasedOnProgress, {}) : hasLearningInterest ? /*#__PURE__*/_jsx(RecommendationsBasedOnInterest, {}) : /*#__PURE__*/_jsx(RecommendationsBasedOnField, {})
  });
};

export default RecommendationsContainer;